import React, { useEffect, useState } from "react";
import { ShieldAlert, X } from "lucide-react";
import client from "@/lib/api";
import { useApp } from "@/context/AppContext";

const fmtIST = (iso) => new Date(iso).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", dateStyle: "medium", timeStyle: "short" });

// One-time alert for admins after the Admin password was rotated via server settings (.env). Never shows the password.
export default function AdminSecurityNotice() {
  const { user } = useApp();
  const isAdmin = !!user?.roles?.includes("admin");
  const [notice, setNotice] = useState(null);
  useEffect(() => {
    setNotice(null);
    if (!isAdmin) return;
    client.get("/admin/security-notice").then((r) => setNotice(r.data.notice)).catch(() => {});
  }, [isAdmin, user?.id]);
  if (!notice) return null;
  const dismiss = () => {
    const id = notice.id;
    setNotice(null);
    client.post(`/admin/security-notice/${encodeURIComponent(id)}/dismiss`).catch(() => {});
  };
  return (
    <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 pt-3" data-testid="admin-security-notice">
      <div role="alert" className="flex items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 text-amber-900 px-4 py-3">
        <ShieldAlert className="w-5 h-5 mt-0.5 flex-shrink-0 text-amber-700" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold" data-testid="admin-security-notice-title">Admin password was changed via server settings</p>
          <p className="text-xs sm:text-sm mt-0.5" data-testid="admin-security-notice-when">
            Changed on {fmtIST(notice.at)} (IST). All older Admin sessions were signed out. If you did not make this change, reset the Admin password immediately.
          </p>
        </div>
        <button type="button" onClick={dismiss} aria-label="Dismiss notice" className="p-3 -m-2 rounded-full hover:bg-black/5 transition-colors flex-shrink-0" data-testid="admin-security-notice-dismiss">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
